import { useCan } from '@/components/can/Can';
import { defaultMeta } from '@/constants/defaultMeta';
import { PERMS } from '@/features/auth/permissions/permissionKeys';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { referralReportQueries } from '@/services/dashboard/referralReports/referralReports.queries';
import { useParams, useSearch } from '@tanstack/react-router';
import type { DateRange } from 'react-day-picker';

export const useAffiliateReferralDetails = (dateRange?: DateRange) => {
  const canReadDetails = useCan({ allOf: [PERMS.affiliate.referral.affiliate.report.view] });
  const { reportType, referrerId } = useParams({
    from: '/(app)/dashboard/referral-reports/$reportType/$referrerId/',
  });
  const { sort, q, referralType } = useSearch({ from: '/(app)/dashboard/referral-reports/$reportType/$referrerId/' });
  const { data, isLoading } = useQuery({
    ...referralReportQueries.affiliateDetails({
      affiliateId: referrerId,
      search: q,
      fromDate: dateRange?.from ? new Date(dateRange.from).setHours(0, 0, 0, 0) : 0,
      toDate: dateRange?.to ? new Date(dateRange.to).setHours(23, 59, 59, 999) : 0,
      referTypeFilter: referralType,
    }),
    enabled: reportType === 'affiliate' && canReadDetails,
    select: (response) => ({ ...response, data: sortBy(response.data ?? [], sort) }),
  });

  return {
    affiliateReferralDetails: data?.data ?? [],
    isLoading,
    pagination: data?.meta?.pagination ?? defaultMeta,
  };
};
